import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { jiraSpaPageContainerResource } from './jiraSpaPageContainerResource.tsx';

export const jiraSpaResources = (): RouteResource[] => [
	resourceWithCondition(() => fg('jpx-463-spa-relay-query'), jiraSpaPageContainerResource),
	themePreferenceResource,
];
